(function () {
    const benefitSlider = () => {
        const sliders = document.querySelectorAll(".benefits__container");

        sliders.forEach((slider) => {
            const parent = slider.closest(".benefits");
            const nextArrow = parent.querySelector(".next");
            const prevArrow = parent.querySelector(".prev");
            const items = slider.querySelectorAll(".benefits__item");
            const columnToShow = parseInt(slider.dataset.columnToShow || 5);

            const updateArrowsVisibility = () => {
                const screenWidth = window.innerWidth;
                const itemCount = items.length;

                if (screenWidth >= 1321) {
                    // On large desktop
                    if (itemCount <= columnToShow) {
                        hideArrows();
                    } else {
                        showArrows();
                    }
                } else if (screenWidth >= 1201) {
                    // On medium desktop
                    if (itemCount <= 3) {
                        hideArrows();
                    } else {
                        showArrows();
                    }
                } else if (screenWidth >= 991) {
                    // On tablets
                    if (itemCount <= 2) {
                        hideArrows();
                    } else {
                        showArrows();
                    }
                } else if (screenWidth >= 576) {
                    // On mobile landscape
                    if (itemCount <= 2) {
                        hideArrows();
                    } else {
                        showArrows();
                    }
                } else {
                    // On mobile portrait
                    if (itemCount <= 1) {
                        hideArrows();
                    } else {
                        showArrows();
                    }
                }
            };

            const hideArrows = () => {
                if (nextArrow) nextArrow.style.display = "none";
                if (prevArrow) prevArrow.style.display = "none";
            };

            const showArrows = () => {
                if (nextArrow) nextArrow.style.display = "";
                if (prevArrow) prevArrow.style.display = "";
            };

            const initSlider = () => {
                articlesSlider = new Swiper(slider, {
                    slidesPerView: "auto",
                    breakpoints: {
                        1024: {
                          slidesPerView: 3,
                        }
                    },
                    navigation: {
                        nextEl: nextArrow,
                        prevEl: prevArrow,
                    },
                    on: {
                        init: updateArrowsVisibility,
                        resize: updateArrowsVisibility,
                    },
                });
            };

            initSlider();

            window.addEventListener("resize", updateArrowsVisibility);

            updateArrowsVisibility();
        });
    };

    document.addEventListener("shopify:section:load", function () {
        benefitSlider();
    });

    // Run on initial page load
    document.addEventListener("DOMContentLoaded", function () {
        benefitSlider();
    });
})();
